import { useLayoutEffect, useRef, useEffect, useState } from 'react'
import * as am5 from '@amcharts/amcharts5'
import * as am5xy from '@amcharts/amcharts5/xy'
import am5themes_Animated from '@amcharts/amcharts5/themes/Animated'
import { getAssessmentByMonth } from '../../../../services/analytics/analytics.service'
import Loading from '../../../Loading/Loading'

const Chart = ({ data }) => {
  const chartRef = useRef(null)

  useLayoutEffect(() => {
    if (!data.length) return
    const root = am5.Root.new(chartRef.current)
    root.setThemes([am5themes_Animated.new(root)])
    root._logo.dispose()
    const chart = root.container.children.push(am5xy.XYChart.new(root, { panX: false, panY: false }))
    const xAxis = chart.xAxes.push(
      am5xy.CategoryAxis.new(root, {
        categoryField: 'month',
        renderer: am5xy.AxisRendererX.new(root, { minGridDistance: 30 })
      })
    )
    const yAxis = chart.yAxes.push(
      am5xy.ValueAxis.new(root, { renderer: am5xy.AxisRendererY.new(root, {}), min: 0 })
    )
    const series = chart.series.push(
      am5xy.ColumnSeries.new(root, {
        name: 'Markings per month',
        xAxis,
        yAxis,
        valueYField: 'markings',
        categoryXField: 'month',
        tooltip: am5.Tooltip.new(root, { labelText: '{month}: {valueY}' })
      })
    )
    series.columns.template.setAll({
      fill: am5.color(0x2b5784),
      stroke: am5.color(0x2b5784),
      cornerRadiusTL: 4,
      cornerRadiusTR: 4
    })
    xAxis.data.setAll(data)
    series.data.setAll(data)
    series.appear(1000)
    chart.appear(1000, 100)
    return () => root.dispose()
  }, [data])

  return <div ref={chartRef} style={{ width: '100%', height: 240 }} />
}

const AssessmentByMonth = () => {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    getAssessmentByMonth()
      .then((res) => setData(res?.data || []))
      .catch((err) => setError(err?.message || 'Error loading markings by month'))
      .finally(() => setLoading(false))
  }, [])

  if (loading) return <Loading />
  if (error)
    return (
      <div style={{ padding: 24, color: '#c0392b' }}>
        <strong>Error:</strong> {error}
      </div>
    )
  if (!data.length) return <p style={{ color: '#888', padding: 24 }}>No monthly data available.</p>

  return (
    <div style={{ padding: 24 }}>
      <h2 style={{ marginBottom: 16, fontSize: 18, fontWeight: 600, color: '#2b5784' }}>
        Markings by Month (last 24 months)
      </h2>
      <Chart data={data} />
    </div>
  )
}

export default AssessmentByMonth
